export const INITIAL_STATE = {
  getDrupalPreviewContent: null,
  getDrupalPreviewContentLoading: false,
  getDrupalPreviewContentSuccess: null,
  getDrupalPreviewContentFailure: null,
};
